import React from 'react';
import { Container } from '@adobe/cq-react-editable-components';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

import { ModalBody, ModalFooter, ModalTitle } from '@vds/modals';
import { batch } from 'react-redux';
import { apiUrls } from '../../../../constants/apiUrl.js';
import { FWAContainer } from '../../../common/FWAContainer';
import { Row, Col } from '../../../common/Grid';
import MiniCart from '../../../common/MiniCart/redesign';
import Button from '../../../common/Button';
import { VDSModal as Modal } from '../../../common/Modal/VDSModal';
import { goToProcessStep, redirectTo } from '../../../../redirection';
import {
  isMobile,
  isTablet,
  isMVA,
  getSession,
  setSession,
  getProcessStep,
  getAPPID,
  getPrefetch,
  isDesktopResolution,
  isCBandProQualifiedSession,
  renderHTML,
  getUrlName,
  getFlowType,
  saveAllProcessSteps,
  enablePegaProcessSteps,
  isJointTransactionFlow,
  isWHWP2,
  prefetchAddonsAsync,
  fetchAddons,
  viewport,
  getWHWSpoCookie,
  getCookie,
  isExpressCheckout,
} from '../../../common/Helpers/index';
import Notification from '../../../common/Notification/redesign/index';
import { store } from '../../../../configureStore';
import { eventDispatcher, updateEventInfo } from '../../../common/Tagging/index';
import { saveItemToStore, getItemFromStore } from '../../../../utils/sessionStorage';
import { lazyWithPreload } from '../../../common/Helpers/lazyWithPrefetch';
import { checkCartidAndLQResponse, redirectToHomePage } from '../../../common/Helpers/commonLog';
import { commonErrors } from '../../../common/Helpers/constants';
import { getChannelId } from '../../../../services/HttpService';
import { getLqAddress } from '../../../common/addressUtils.js';
import { setNavigationTitle } from '../../../common/MVAApiCall.js';
// import { callPerformanceMeasure } from '../../../common/Helpers/performanceMeasure';
import DesktopCart from '../../../NextGen/OrderSummary/DesktopCart';
// import StickyCart from '../../../NextGen/OrderSummary/StickyCart';

export default class BaseTemplate extends Container {
  constructor(props) {
    super(props);
    this.isTablet = isTablet();
    this.isMobile = isMobile();
    this.isMVA = isMVA();

    checkCartidAndLQResponse('addOns');
    this.handleAddonsLoad = this.handleAddonsLoad.bind(this);
  }

  componentDidMount() {
    if (!isWHWP2()) {
      this.props.getCartDataFromApi();
    }
    if (!this.state.invokeTagging && isWHWP2()) {
      this.props.invokeTaggingAPI();
      this.setState({ invokeTagging: true });
    }
    document.title = 'Home Addons';
    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        this.performPreFetch();
      }
    };
    if (fetchAddons()) {
      if (!prefetchAddonsAsync() && this.props.addOnApiFlag) {
        this.props.getAddons();
      } else if (this.props.nextProcessStep === '') {
        this.props.getAddons();
      }
    } else if (prefetchAddonsAsync()) {
      if (!this.props.addOnApiFlag) {
        this.props.getAddons();
      }
    } else {
      this.props.getAddons();
    }

    const isResumeFlowFlag = getItemFromStore('isResumeFlow');
    if (isResumeFlowFlag === 'true') {
      updateEventInfo('event86');
      saveItemToStore('isResumeFlow', false);
    }
    const allProcessStep = saveAllProcessSteps();
    if (isJointTransactionFlow()) {
      this.props.showCart(false);
    }
    batch(() => {
      store.dispatch({ type: 'ALL_PROCESS_STEP', value: allProcessStep });
      store.dispatch({ type: 'CEF_ADDONS_API_ERROR', errorDetails: false, errorMessage: null });
      store.dispatch({ type: 'CEF_CART_ERROR', response: false, errorMessage: null });
      store.dispatch({ type: 'UPDATE_API_STATUS', response: 'IN_PROGRESS' });
      store.dispatch({ type: 'UPDATED_ADDONS_PROCESSSTEP', value: false });
      store.dispatch({ type: 'WHW_BASIC_DATA', value: this.props.cqItems.wHWBasic });
    });
    setNavigationTitle(this.isMVA, document.title);
  }

  handleAddonsLoad = () => {
    const pageName = getUrlName(window.location.href);
    const markerValue = `${pageName}:ui:${getChannelId()}:${getFlowType()}:render`;

    if (window?.performance?.measure) {
      window.performance.measure(markerValue);
    }
  };

  componentWillUnmount() {
    window.removeEventListener('load', this.handleAddonsLoad);
  }

  componentDidUpdate() {
    // added to share the session id to pdm/nse api call
    if (this.props.channelSession && !this.state?.apiCalled) {
      const isLoggedIn = getAPPID() === 'AAL';
      const pageNameData = {
        pageName: 'addons',
      };
      if (!isLoggedIn) {
        this.props.updatePdc(pageNameData);
        this.setState({ apiCalled: true });
      }
    }
    if (!this.state.invokeTagging && this.props.cartDetails?.apiStatus === 'COMPLETED' && !isWHWP2()) {
      this.props.invokeTaggingAPI();
      this.setState({ invokeTagging: true });
    }
    // if (this.props.apiLoaded) {
    //   callPerformanceMeasure();
    // }
    // if (document.readyState === 'complete') {
    //   callPerformanceMeasure();
    // }
    if (this.props?.visionPendingApiStatus) {
      const updateView = {
        nextStep: 'Confirmation',
        nextViewPage: 'confirmation.html',
        currentStep: 'Addons',
        previousStep: 'CPC',
      };
      goToProcessStep(updateView, this.props.history);
    }
  }

  updateAddonsTaggingInfoMessage = (taggingMessage) => {
    if (!this.state.addonsInfoTagging) {
      eventDispatcher('sendData', {
        name: '',
        svars: {
          evar13: taggingMessage || '',
          evar22: 'message displayed',
        },
      });
      this.setState({ addonsInfoTagging: true });
    }
  };

  callNpaNxx = (e, eventName) => {
    e.preventDefault();
    const isSkipMtnApi = window.vzFlags?.isSkipMtnApi || false;
    if (!isSkipMtnApi) {
      const lqShippingAddress = getLqAddress();
      if (lqShippingAddress) {
        const postData = {
          state: lqShippingAddress.state,
          city: lqShippingAddress.city,
          zipcode: lqShippingAddress.zipCode,
          mdnCountRequired: true,
          sortTypeDesc: true,
        };
        this.props.callNPANXX(postData);
      }
    }
    this.setState({ eventName });
    this.props.invokeTaggingflag(false);
    setSession('addonBack', true);
    const addonRefData = this.props.addonObj;
    this.props.setAddonsRef(addonRefData && addonRefData.slice());
    this.props.updateAssignMtnStatus(true);
  };

  performPreFetch = () => {
    if (!getPrefetch()) {
      return;
    }
    const flowType = getSession('FlowType');
    const isCBandQual = getSession('isCBandQual');
    if ((flowType === '5G' && isCBandQual === 'Y') || flowType === 'LTE') {
      const ComponentToPreload = lazyWithPreload(() => import(/* webpackPrefetch: true */ '../../Cart/redesign/index'));
      if (typeof ComponentToPreload?.preload === 'function') {
        ComponentToPreload.preload();
      }
    } else if (flowType === '5G' && isCBandQual !== 'Y') {
      const ComponentToPreload = lazyWithPreload(() => import(/* webpackPrefetch: true */ '../../DeviceSetup/redesign/index'));
      if (typeof ComponentToPreload?.preload === 'function') {
        ComponentToPreload.preload();
      }
    }
  };

  modalChanged = (state) => {
    if (!state) {
      store.dispatch({ type: 'CLOSE_MODAL' });
      eventDispatcher('linkClick', {
        type: 'link',
        name: `close`,
        data: { page: { detail: `${this.props?.shipmentPendingheader} modal` } },
      });
      window.location.href = apiUrls().redirectPMD;
    }
  };

  VisionModalChanged = (state) => {
    store.dispatch({ type: 'VISION_PENDING_STATUS', value: state });
    if (!state) {
      eventDispatcher('linkClick', {
        type: 'link',
        name: `close`,
        data: { page: { detail: `vision pending modal` } },
      });
    }
  };

  downgradeModalChange = (value) => {
    this.setState({ downgradeFlow: value });
    if (!value) {
      eventDispatcher('linkClick', {
        type: 'link',
        name: `close`,
        data: { page: { detail: `Details | ${this.props?.downgradeHeader} modal` } },
      });
    }
  };

  visionPendingConfirm = (e) => {
    e.preventDefault();
    const SessionValueWHW = viewport() === 'mfapp' ? getWHWSpoCookie('whwSpoDetails') : getSession('whwSpoDetails');
    const parsedRedemptionSession = SessionValueWHW && JSON.parse(SessionValueWHW);
    const visionData = {
      processingMTN: viewport() === 'mfapp' ? getCookie('whwProcessingMTN') : getSession('whwProcessingMTN'),
      visionPendingNumber: parsedRedemptionSession?.visionPendingOrder,
      mon: parsedRedemptionSession?.mon,
    };
    this.props.confirmVisionPendingOrderapi(visionData);
  };

  onClickButton = (e) => {
    e.preventDefault();
    const SessionValueWHW = viewport() === 'mfapp' ? getWHWSpoCookie('whwSpoDetails') : getSession('whwSpoDetails');
    const parsedRedemptionSession = SessionValueWHW && JSON.parse(SessionValueWHW);
    const redemptionShipmentPending = parsedRedemptionSession?.pendingShipment;
    const pastDueSession = viewport() === 'mfapp' ? getCookie('pastDue') : getSession('pastDue');
    const pastDue = pastDueSession && JSON.parse(pastDueSession);
    const visionPending = parsedRedemptionSession?.visionPendingOrder;
    const mon = parsedRedemptionSession?.mon;
    const visionPendingOrder = visionPending && mon && visionPending !== '' && visionPending !== null && mon !== '' && mon !== null;
    if (isWHWP2() && pastDue) {
      this.setState({ pastDue: true });
    } else if (isWHWP2() && this.props?.isDowngradeRedemption && !visionPendingOrder) {
      const updateView = {
        nextStep: 'OrderReview',
        nextViewPage: 'orderreview.html',
        currentStep: 'Addons',
        previousStep: 'CPC',
      };
      goToProcessStep(updateView, this.props.history);
    } else if (isWHWP2() && !redemptionShipmentPending) {
      const updateView = {
        nextStep: 'Shipping',
        nextViewPage: 'shipping.html',
        currentStep: 'Addons',
        previousStep: 'CPC',
      };
      goToProcessStep(updateView, this.props.history);
    } else {
      this.callNpaNxx(e, 'continueBtn');
    }
  };

  doUpdateProcessStep = (isEditFromCart, processStep) => {
    if (this.state.eventName !== undefined && !this.state.updateProcessStepCalled) {
      /** isTGW - Tanglewood Key , For TGWflow Setup page is skipped since we support only Profressional setup  
      const isTgwFlow = getSession('isTGW');
      if (isTgwFlow) {
        const updateView = {
          nextStep: 'Cart',
          nextViewPage: 'cart.html',
          currentStep: 'Addons',
          previousStep: 'PlansOverview',
        };
        goToProcessStep(updateView, this.props.history);
      } */
      if (isEditFromCart === 'Y') {
        this.props.updateProcessStepAddons(this.state.eventName, processStep);
      } else {
        this.props.updateProcessStepAddons(this.state.eventName, 'Accessories');
      }
      this.setState({ updateProcessStepCalled: true });
    }
  };

  render() {
    const isEditFromCart = getSession('isEditFromCart');
    const processStep = getProcessStep();
    const { whwDowngradeConflictModalHeader, whwDowngradeConflictModalBody } =
      this.props.plansReferenceData?.output?.addonsContent?.whwFallback || {};
    const isPegaProcessSteps = enablePegaProcessSteps();
    if (this.props.addonsData.isAssignMtnSuccess && this.state.eventName !== undefined && !isPegaProcessSteps && !isWHWP2()) {
      const flowType = getSession('FlowType');
      const isCBandQualified = getSession('isCBandQual');

      let updateView = this.props.currentView.FiveG;
      const cartEligibleBundles = this.props.cartDetails?.cartDetailsJson?.orderDetailsView?.eligible5GHomeBundle || [];
      /** const isTgwFlow = getSession('isTGW'); */

      // Skip Setup page if EligibleBundles < 2 or TGW
      if (cartEligibleBundles.length < 2) {
        updateView = this.props.currentView.CBandFiveG;
      }
      if (flowType !== 'LTE' && isCBandQualified === 'Y' && !isCBandProQualifiedSession()) {
        updateView = this.props.currentView.CBandFiveG;
      }
      if (isEditFromCart === 'Y') {
        updateView = this.props.currentView.Edit;
      } else if (flowType === 'LTE') {
        updateView = this.props.currentView.LTE;
      }

      this.doUpdateProcessStep(isEditFromCart, processStep);

      /** if (isTgwFlow) {
        updateView = {
          nextStep: 'Cart',
          nextViewPage: 'cart.html',
          currentStep: 'Addons',
          previousStep: 'PlansOverview',
        };
        goToProcessStep(updateView, this.props.history);
      } */
      if (isExpressCheckout()) {
        updateView = this.props.currentView?.ExpressCheckout;
      }
      if (updateView !== undefined) {
        this.props.updateAssignMtnStatus(false);
      }

      const isJoint = isJointTransactionFlow();
      const { nextViewPage } = updateView || {};
      if (isJoint && ['cart.html', 'setup.html'].includes(nextViewPage)) {
        window.location.href = `${apiUrls().redirectNextgenCart}`;
      } else {
        goToProcessStep(updateView, this.props.history);
      }
    }

    if (isPegaProcessSteps && this.props.addonsData.isAssignMtnSuccess && this.state.eventName !== undefined && !isWHWP2()) {
      this.doUpdateProcessStep(isEditFromCart);
      if (this.props.updateAddonsProcessstep) {
        this.props.updateAssignMtnStatus(false);
        if (isJointTransactionFlow() && this.props.nextProcessStep === '/nextgen/expresscart.html') {
          window.location.href = `${apiUrls().redirectNextgenCart}`;
        } else if (this.props.nextProcessStep && !isExpressCheckout()) {
          redirectTo(this.props.nextProcessStep, this.props.history);
        } else if (isExpressCheckout()) {
          const nextView = this.props.currentView?.ExpressCheckout;
          goToProcessStep(nextView, this.props.history);
        }
      }
    }
    const addOnComponents = this.childComponents.filter(
      (item) => !(item.key.indexOf('/miniCartDueToday') >= 0 || item.key.indexOf('/miniCartDueMonthly') >= 0),
    );
    const miniCartComponents = this.childComponents.filter(
      (item) => item.key.indexOf('/miniCartDueToday') >= 0 || item.key.indexOf('/miniCartDueMonthly') >= 0,
    );
    // const skipButton = this.props.addonsData.isSkip;
    // Skip button handled during addons page initial load
    // Skip button in Back to Addons or Edit from cart - Scenarios handled below
    const isError = this.props.addonsData.showError || this.props.cartDetails.showCartApiError;
    const { showAddonApiError, addonsError, addonsNtfyMsg } = this.props.addonsData; // api failure
    const apiflag = this.props.addOnApiFlag; // api success

    if (!apiflag && !showAddonApiError) {
      return null;
    }

    const notificationProps = {
      renderIf: false,
      title: '',
      type: '',
      subtitle: '',
      hideCloseButton: false,
    };
    if ((addonsError || this.props.cartDetails.cartError) && !this.props.addonsinvalidCaseError) {
      notificationProps.renderIf = true;
      notificationProps.title = renderHTML(addonsNtfyMsg || this.props.cartDetails?.cartNtfyMsg || this.props.notifyMessage);
      notificationProps.type = 'warning';
    } else if ((isError || showAddonApiError) && !this.props.addonsinvalidCaseError) {
      notificationProps.renderIf = (isError || showAddonApiError) && !this.props.addonsinvalidCaseError;
      notificationProps.title = this.props.notifyMessage;
      notificationProps.type = 'warning';
    } else if (this.props.addonsinvalidCaseError) {
      notificationProps.renderIf = this.props.addonsinvalidCaseError;
      notificationProps.title = parse(commonErrors?.transactionExpired || '');
      notificationProps.type = 'warning';
    } else if (!(this.isMobile || this.isMVA) && this.props.addonsData.showAddNotification !== '') {
      notificationProps.renderIf = !(this.isMobile || this.isMVA) && this.props.addonsData.showAddNotification !== '';
      notificationProps.title = this.props?.addonsData?.showAddNotification;
      notificationProps.type = 'info';
      notificationProps.hideCloseButton = true;
      this.updateAddonsTaggingInfoMessage(this.props?.addonsData?.showAddNotification);
    }
    if (isWHWP2() && this.state.pastDue) {
      notificationProps.renderIf = isWHWP2() && this.state.pastDue;
      notificationProps.title = this.props?.pastDueNotificationTitle;
      notificationProps.subtitle = this.props?.pastDueNotificationSubtitle;
      notificationProps.type = 'warning';
      notificationProps.hideCloseButton = true;
      notificationProps.buttonData = [
        {
          children: 'Clear dues',
          onClick: () => {
            window.location.href = apiUrls().redirectPayBalance;
          },
          'data-track': `{"type": "link",  "name": "Clear dues"}`,
        },
      ];
    }
    if (isWHWP2() && getSession('downgradeDetails') && this.props?.isDowngradeRedemption && this.props?.addFeatureapiStatus) {
      const returnedQuantity = JSON.parse(getSession('downgradeDetails')).returnqty;
      notificationProps.renderIf = isWHWP2() && getSession('downgradeDetails') && JSON.parse(getSession('downgradeDetails')).Downgrade;
      notificationProps.title = this.props?.downgradeTitle;
      notificationProps.subtitle = this.props?.downgradeSubTitle.replace('XX.XX', returnedQuantity);
      notificationProps.type = 'warning';
      notificationProps.hideCloseButton = true;
      notificationProps.buttonData = [
        {
          children: 'Details',
          onClick: () => this.setState({ downgradeFlow: true }),
          'data-track': `{"type": "link",  "name": "Details", "data":{"page":{"detail":"Details | ${this.props?.downgradeHeader} modal" }}}`,
        },
      ];
    }
    const link = document.getElementById('transactionExpiryLink');
    if (link) {
      link.addEventListener('click', redirectToHomePage);
    }
    return (
      <div className={isMobile() ? 'buttonSpacing' : ''}>
        <Notification {...notificationProps} />
        <Row>
          <Col>
            {this.props.isModalOpen && (
              <Modal
                opened={this.props.isModalOpen}
                data-track="{}"
                onOpenedChange={this.modalChanged}
                disableOutsideClick
                openViewData={{
                  name: `${this.props?.shipmentPendingheader} modal`,
                  selector: '##visionPendingModal',
                }}
              >
                <ModalTitle> {this.props?.shipmentPendingheader}</ModalTitle>
                <ModalBody>{this.props?.shipmentPendingdescription}</ModalBody>
                <ModalFooter>
                  <Button
                    width={isMobile() ? '100%' : 'auto'}
                    onClick={() => {
                      store.dispatch({ type: 'CLOSE_MODAL' });
                      window.location.href = apiUrls().redirectPMD;
                    }}
                    data-track={`{"type": "link", "name": "Got it","data":{"page":{"detail":" ${this.props?.shipmentPendingheader} modal" }}}`}
                  >
                    Got it
                  </Button>
                </ModalFooter>
              </Modal>
            )}
            {this.props?.visionPendingOrder && (
              <Modal
                ariaLabel="shipment pending overlay"
                analyticstrack="redemption shipment pending"
                opened={this.props?.visionPendingOrder}
                data-track="{}"
                onOpenedChange={this.VisionModalChanged}
                disableOutsideClick
                openViewData={{
                  name: `Vision Pending modal`,
                  selector: '##visionPendingModal',
                }}
              >
                <ModalTitle>{this.props.whwDowngradeConflictModalHeader || whwDowngradeConflictModalHeader}</ModalTitle>
                <ModalBody>{parse(this.props.whwDowngradeConflictModalBody || whwDowngradeConflictModalBody)}</ModalBody>
                <ModalFooter
                  buttonData={{
                    primary: {
                      children: 'Confirm',
                      size: 'large',
                      use: 'primary',
                      onClick: (e) => {
                        this.visionPendingConfirm(e);
                        store.dispatch({ type: 'VISION_PENDING_STATUS', value: false });
                      },
                      dataTrack: `{"type": "link", "name": "Confirm","data":{"page":{"detail":"Vision Pending modal modal" }}}`,
                    },
                    close: {
                      children: 'Cancel',
                      size: 'large',
                      use: 'secondary',
                      onClick: () => store.dispatch({ type: 'VISION_PENDING_STATUS', value: false }),
                      dataTrack: `{"type": "link", "name": "Cancel","data":{"page":{"detail":"Vision Pending modal modal" }}}`,
                    },
                  }}
                />
              </Modal>
            )}
            {this.state.downgradeFlow && (
              <Modal
                opened={this.state.downgradeFlow}
                data-track="{}"
                onOpenedChange={this.downgradeModalChange}
                openViewData={{
                  name: `Details | ${this.props?.downgradeHeader} modal`,
                  selector: '#DowngradeModal',
                }}
                disableOutsideClick
              >
                <ModalTitle> {this.props?.downgradeHeader}</ModalTitle>
                <ModalBody>
                  <div dangerouslySetInnerHTML={{ __html: this.props?.downgradeDescription }} />
                </ModalBody>
                <ModalFooter>
                  <Button
                    width={isMobile() ? '100%' : 'auto'}
                    onClick={() => this.setState({ downgradeFlow: false })}
                    data-track={`{"type": "link", "name": "Got it","data":{"page":{"detail":"Details | ${this.props?.downgradeHeader} modal" }}}`}
                  >
                    Got it
                  </Button>
                </ModalFooter>
              </Modal>
            )}
          </Col>
        </Row>
        <FWAContainer className="vz-5g-streamingDevices" topBufferAuto enableLiveSupport title={this.props.title}>
          <Row>
            <Col colSizes={{ mobile: 4, tablet: 12, desktop: 8 }} className="noPadding">
              {addOnComponents}
              <Col colSizes={{ mobile: 12, tablet: 9, desktop: 8 }} className={isTablet() ? 'leftPad20' : ''}>
                {/* {!isDesktopResolution() && isExpressCheckout() && <StickyCart btnName="Review Order" callBtnMethod={this.onClickButton} />} */}
                {!isDesktopResolution() &&
                  (!isWHWP2() ||
                    (isWHWP2() && this.props?.cartDetails?.cartDetailsJson) ||
                    (isWHWP2() && this.props?.isDowngradeRedemption && this.props?.addFeatureapiStatus)) && (
                    <Button
                      className={isMobile() ? 'marginTop40 marginBottom20' : 'marginTop40'}
                      analyticstrack="5G-Accessories-Continue"
                      data-track={
                        isExpressCheckout()
                          ? '{"type":"link","name":"review order","data":{"page":{"throttle":"nsa version|vhi|ec y"},"target":{"sandBox":"FWA_Express_T_Checkout"}}}'
                          : true
                      }
                      onClick={(e) => {
                        this.onClickButton(e);
                      }}
                      size="large"
                      width={isMobile() ? '100%' : 'auto'}
                      primary
                    >
                      {isExpressCheckout() ? 'Review Order' : this.props.showSkipButton || isWHWP2() ? 'Continue' : 'Skip and continue'}
                    </Button>
                  )}
              </Col>
            </Col>
            <Col colSizes={{ mobile: 0, tablet: 3, desktop: 4 }} className={this.props?.isDowngradeRedemption ? 'marginTopAuto' : ''}>
              {isDesktopResolution() &&
                (!isWHWP2() ||
                  (isWHWP2() && this.props?.cartDetails?.cartDetailsJson) ||
                  (isWHWP2() && this.props?.isDowngradeRedemption && this.props?.addFeatureapiStatus)) && (
                  <div className={!this.props?.isDowngradeRedemption && 'widthFitContent'}>
                    {isExpressCheckout() && <DesktopCart />}
                    {!isExpressCheckout() && !this.props?.isDowngradeRedemption && (
                      <MiniCart
                        miniCartComponents={miniCartComponents}
                        showCartStatus={(iscartVisibleVal) => this.props.showCart(iscartVisibleVal)}
                        iscartVisible={this.props.cartDetails.isCartVisible}
                        showOnlyForDesktopView
                        topMarginStyle={140}
                      />
                    )}
                    <Button
                      className={this.props?.isDowngradeRedemption ? '' : 'marginTop20 marginBottom32'}
                      analyticstrack="5G-Accessories-Continue"
                      data-track="true"
                      onClick={(e) => {
                        this.onClickButton(e);
                      }}
                      size="large"
                      width="100%"
                      primary
                    >
                      {isExpressCheckout() ? 'Review Order' : this.props.showSkipButton || isWHWP2() ? 'Continue' : 'Skip and continue'}
                    </Button>
                  </div>
                )}
            </Col>
          </Row>
        </FWAContainer>
      </div>
    );
  }
}

BaseTemplate.propTypes = {
  invokeTaggingAPI: PropTypes.func,
};
